import type { CityConfig } from "../city-template/types";

export const muskegonConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Michigan DHHS Vital Records", href: "https://www.michigan.gov/mdhhs/adult-child-serv/informedconsent/vitalrecords", description: "Official Michigan vital records office in Lansing" },
    { label: "Marriage Licenses — Muskegon County Clerk", href: "https://www.co.muskegon.mi.us/clerk", description: "Muskegon County Clerk — marriage license issuance" },
    { label: "Divorce Records — Muskegon County Clerk", href: "https://www.co.muskegon.mi.us/clerk", description: "Muskegon County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Michigan DHHS for online vital record orders" },
  ],
  city: "Muskegon",
  state: "Michigan",
  stateAbbr: "MI",
  slug: "muskegon",
  route: "/muskegon",
  title: "Emergency Passport Muskegon, MI — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Muskegon, Michigan — as fast as 24 hours. Fast passport renewal and new passport applications for Muskegon, Norton Shores, Roosevelt Park, Fruitport, and all West Michigan Lake Michigan coast residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Muskegon, MI",
  heroSubtitle: "Muskegon travelers — from the Pere Marquette Beach boardwalk to the downtown lakeshore district to the Whitehall and Montague communities — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of Muskegon County and the Lake Michigan coast.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20aerial%20view%20of%20Muskegon%20Michigan%20Lake%20Michigan%20shoreline%20with%20Pere%20Marquette%20Beach%2C%20sandy%20beach%20and%20blue%20lake%20waters%2C%20historic%20downtown%20buildings%20near%20the%20harbor%2C%20the%20USS%20Silversides%20submarine%20museum%20visible%2C%20Muskegon%20Lake%20inlet%2C%20lush%20green%20summer%20trees%2C%20vibrant%20West%20Michigan%20lakeshore%20atmosphere%2C%20warm%20golden%20afternoon%20sunlight%2C%20professional%20city%20photography%20without%20text%20or%20people&width=1800&height=700&seq=muskegon-hero-001&orientation=landscape",
  heroImageAlt: "Muskegon Michigan Lake Michigan shoreline with Pere Marquette Beach and downtown harbor district",
  geoPosition: "43.2342;-86.2484",
  geoPlacename: "Muskegon, Michigan",
  lastModified: "2026-06-02",
  regionalAgency: {
    name: "Detroit Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 3 hours southeast of Muskegon via US-131 and I-96",
  },
  nearbyCitiesZips: [
    { name: "Muskegon", zips: "49440, 49441, 49442, 49443, 49444, 49445" },
    { name: "Norton Shores", zips: "49441, 49444, 49456" },
    { name: "Roosevelt Park", zips: "49441" },
    { name: "Fruitport", zips: "49415" },
    { name: "Whitehall", zips: "49461" },
    { name: "Montague", zips: "49437" },
    { name: "North Muskegon", zips: "49445" },
    { name: "Muskegon Heights", zips: "49444" },
    { name: "Twin Lake", zips: "49457" },
    { name: "Holton", zips: "49425" },
    { name: "Lakewood Club", zips: "49457" },
    { name: "Dalton", zips: "49445" },
    { name: "Moorland", zips: "49437" },
    { name: "Sullivan", zips: "49451" },
    { name: "Spring Lake", zips: "49456" },
    { name: "Grand Haven", zips: "49417" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Detroit or Chicago — no 3-hour drive required" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-building-line", title: "Lake Michigan Coast Hub", desc: "Serving Muskegon, Norton Shores, Whitehall, and the lakeshore communities" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — ship from any Muskegon County UPS or FedEx" },
  ],
  internalLinks: [
    { name: "Expedited passport in Grand Rapids, MI", route: "/grand-rapids" },
    { name: "Emergency passport help in Holland, MI", route: "/holland" },
    { name: "Urgent passport services in Kent County, MI", route: "/kent-county" },
    { name: "Michigan passport services overview", route: "/michigan" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Muskegon, Michigan remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Detroit Passport Agency (3 hours southeast via US-131 and I-96) or Detroit Passport Agency (2.5 hours south via I-96 and I-94) — whichever is fastest. Muskegon residents can ship from any UPS or FedEx in Muskegon County.",
  fpcOfficeDistance: "Serving Muskegon, Norton Shores, Roosevelt Park, Fruitport, Whitehall, Montague, North Muskegon, Muskegon Heights, Twin Lake, Holton, Spring Lake, Grand Haven, and all of Muskegon County and the Lake Michigan coast",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Muskegon and the West Michigan Lake Michigan coast. From the Pere Marquette Beach boardwalk to the downtown harbor district, from Norton Shores to the Whitehall and Montague communities — we serve all of Muskegon County and beyond.",
  nearbyCitiesIntro: "We serve Muskegon and all nearby communities including Norton Shores, Roosevelt Park, Fruitport, Whitehall, Montague, North Muskegon, Muskegon Heights, Twin Lake, Holton, Lakewood Club, Dalton, Moorland, Sullivan, Spring Lake, and Grand Haven. We also serve Ottawa County and the northern Lake Michigan coast.",
  howItWorksIntro: "Most Muskegon travelers complete everything online and ship documents overnight. No need to drive 3 hours to Detroit — our couriers handle the agency delivery and always pick the fastest route.",
  mistakesIntro: "Muskegon is the gateway to the West Michigan Lake Michigan coast with significant summer tourism and ferry travel to Milwaukee. Here are the most common passport mistakes we see from Muskegon County travelers.",
  testimonialsIntro: "Muskegon travelers — from lakeshore families to the USS Silversides museum visitors to the Pere Marquette Beach community — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Muskegon, MI? Here are the most common ones we hear from Muskegon County and Lake Michigan coast travelers.",
  statePageRoute: "/states/michigan",
  statePageName: "Michigan",
  dmvWebsite: "https://www.michigan.gov/sos",
  dmvLabel: "Michigan SOS — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Detroit or Chicago agency — fastest option chosen", "No long drive required", "Perfect for Lake Michigan ferry and summer travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Detroit or Chicago agency — fastest option chosen", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 3 hours to Detroit or 2.5 to Chicago", "Full day commitment — difficult from Muskegon"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Muskegon travelers with immediate departure needs — as fast as 24 hours. Our couriers use Detroit or Chicago agency — whichever is fastest. Perfect for last-minute ferry travel and summer vacations.",
      bullets: ["24–48 hour turnaround available", "Detroit or Chicago agency — fastest route chosen", "Lake Michigan coast and ferry travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Muskegon adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Muskegon County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Muskegon residents and families — including new citizens, students, and West Michigan families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Muskegon residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Muskegon and West Michigan families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Muskegon and West Michigan residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Muskegon MI", description: "Urgent passport processing for Muskegon Michigan travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Muskegon MI", description: "Fast passport renewal for Muskegon Michigan residents with a previously-issued passport." },
    { name: "First-Time Passport Muskegon MI", description: "New passport application services for Muskegon Michigan residents applying for their first passport." },
    { name: "Child Passport Muskegon MI", description: "Minor passport services for Muskegon Michigan families with children under 16." },
  ],
  testimonials: [
    {
      name: "Lisa H.",
      location: "Muskegon, MI",
      rating: 5,
      text: "Lake Michigan cruise to Milwaukee in 6 days and my passport was expired. Fast Passport Center had my renewal in 3 days. I shipped from the UPS Store on Henry and the whole process was seamless. Great for lakeshore travelers.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Mark S.",
      location: "Norton Shores, MI",
      rating: 5,
      text: "Family trip to Puerto Rico in 9 days. Four passports — two renewals and two first-time for our kids. Done in 5 days. We shipped from FedEx in Norton Shores and everything was perfect. Saved our vacation.",
      service: "Family Passport Bundle",
    },
    {
      name: "Karen D.",
      location: "Whitehall, MI",
      rating: 5,
      text: "Business trip to Toronto with 5 days notice. Fast Passport Center walked me through every step and had my passport in 2 days. Living on the Lake Michigan coast, I was worried about timing. They came through.",
      service: "Emergency Passport",
    },
    {
      name: "Paul J.",
      location: "Muskegon, MI",
      rating: 5,
      text: "Lost my passport the week before a fishing trip to Alaska. Fast Passport Center replaced it in 48 hours. I shipped from the downtown UPS and everything was perfect. A+ service for the Muskegon area.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "muskegon-1",
      name: "Muskegon Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "333 W Webster Ave",
      city: "Muskegon",
      state: "MI",
      zip: "49440",
      phone: "(231) 722-3331",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Muskegon, near the harbor district",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary downtown Muskegon acceptance facility. Convenient for downtown residents and the harbor district. Appointments required — book 1–2 weeks in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "muskegon-2",
      name: "Norton Shores Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "4807 Harvey St",
      city: "Norton Shores",
      state: "MI",
      zip: "49441",
      phone: "(231) 733-4411",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Norton Shores, approximately 5 miles south of downtown Muskegon",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Norton Shores, Roosevelt Park, and southern Muskegon residents. Located near the Harvey Street corridor.",
      icon: "ri-mail-line",
    },
    {
      id: "muskegon-3",
      name: "Whitehall Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "405 E Colby St",
      city: "Whitehall",
      state: "MI",
      zip: "49461",
      phone: "(231) 894-4511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Whitehall, approximately 12 miles north of Muskegon",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Whitehall, Montague, and northern Muskegon County. Good alternative for north-side travelers.",
      icon: "ri-mail-line",
    },
    {
      id: "muskegon-4",
      name: "Fruitport Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "35 3rd Ave",
      city: "Fruitport",
      state: "MI",
      zip: "49415",
      phone: "(231) 865-3411",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Fruitport, approximately 8 miles east of Muskegon",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Fruitport, Lakewood Club, and eastern Muskegon County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "muskegon-5",
      name: "Muskegon County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "990 Terrace St",
      city: "Muskegon",
      state: "MI",
      zip: "49440",
      phone: "(231) 724-6311",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Downtown Muskegon County Building",
      website: "https://www.co.muskegon.mi.us/",
      websiteLabel: "Muskegon County",
      notes: "County Clerk passport acceptance. Extended hours compared to some post office locations. Call to confirm current passport acceptance hours.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 3 hour drive to Detroit", fpc: "No — ship from Muskegon" },
    { feature: "Agency Selection", agency: "Must choose one yourself", fpc: "We pick Detroit or Chicago — fastest available" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Muskegon families and summer tourists often discover passport issues just before Lake Michigan ferry or Caribbean travel. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services near the Lakes Mall or downtown Muskegon sometimes produce photos that meet ID requirements but fail passport standards. Photos must be exactly 2x2 inches on a white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Muskegon County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities Early Enough",
      description: "Muskegon and Norton Shores Post Office appointments fill during summer tourist season and before Lake Express ferry season. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-road-map-line",
      title: "Underestimating the Drive to Detroit",
      description: "Many Muskegon residents attempt to drive to a passport agency in an emergency. The 3-hour drive each way means a full day lost — our courier service is faster and more reliable.",
    },
    {
      icon: "ri-time-line",
      title: "Not Checking Ferry Travel Requirements",
      description: "The Lake Express ferry to Milwaukee is popular with Muskegon travelers. While domestic travel, many continue on to international destinations. Always verify passport requirements for your full itinerary.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in the Muskegon area or Lake Michigan coast." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx near downtown Muskegon or the Lakes Mall area." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to Detroit or Detroit Passport Agency — whichever is fastest for you." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Muskegon address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Muskegon, MI?", a: "Fast Passport Center offers emergency passport processing in Muskegon, Michigan in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Detroit Passport Agency (3 hours southeast via US-131 and I-96) or Detroit Passport Agency (2.5 hours south via I-96 and I-94) — without you making the drive." },
    { q: "Does Muskegon have its own passport agency?", a: "No — Muskegon does not have a regional passport agency. The nearest facilities are the Detroit Passport Agency (approximately 3 hours southeast) and the Detroit Passport Agency (approximately 2.5 hours south). Fast Passport Center's courier service means Muskegon residents never need to make either drive." },
    { q: "Can I get an expedited passport in Norton Shores, Whitehall, or Fruitport?", a: "Absolutely. Fast Passport Center serves all of Muskegon County including Norton Shores, Whitehall, Fruitport, Montague, Roosevelt Park, North Muskegon, and all surrounding communities. Our service works the same way everywhere in the region." },
    { q: "What airport do Muskegon travelers use for international flights?", a: "Muskegon travelers typically use Gerald R. Ford International Airport (GRR) in Grand Rapids, approximately 50 minutes south via US-131. GRR offers direct flights to Atlanta, Dallas, Orlando, and seasonal Caribbean destinations. For larger international hubs, Detroit Metro (DTW) is approximately 3 hours southeast. Always verify passport validity for at least 6 months past your return date." },
    { q: "Does the Lake Express ferry to Milwaukee require a passport?", a: "The Lake Express ferry from Muskegon to Milwaukee is domestic travel within the United States, so a passport is not required. However, many Muskegon travelers continue from Milwaukee to international destinations. If your final destination is outside the U.S., you will need a valid passport. We recommend having a passport for maximum travel flexibility." },
    { q: "How much does an expedited passport cost in Muskegon, MI?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Muskegon?", a: "Walgreens, CVS, and Walmart stores throughout Muskegon and Norton Shores offer passport photos. UPS Store and FedEx Office locations also provide them. The Walgreens on Henry Street and Walmart on E Sherman Boulevard are convenient options. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve the Lake Michigan coast communities?", a: "Yes. Fast Passport Center serves all of the Lake Michigan coast including Muskegon, Norton Shores, Whitehall, Montague, Fruitport, Spring Lake, and Grand Haven. Whether you live in the city or along the lakeshore, our service works the same way." },
  ],
  photoLocations: [
    { name: "Walgreens — Henry Street Muskegon", address: "1805 E Sherman Blvd, Muskegon, MI 49444", hours: "Mon–Sun: 7AM–10PM" },
    { name: "Walmart — Muskegon Supercenter", address: "1879 E Sherman Blvd, Muskegon, MI 49444", hours: "Mon–Sun: 6AM–11PM" },
    { name: "UPS Store — Downtown Muskegon", address: "350 W Western Ave, Muskegon, MI 49440", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "CVS — Norton Shores", address: "4807 Harvey St, Muskegon, MI 49441", hours: "Mon–Sun: 8AM–10PM" },
  ],
  dmvLocations: [
    { name: "Michigan SOS — Muskegon", address: "270 Baker St, Muskegon, MI 49442", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Michigan Secretary of State for driver's licenses, REAL ID, and vehicle registration. Downtown Muskegon location. Online reservations strongly recommended.", featured: true },
    { name: "Michigan SOS — Norton Shores", address: "5795 Harvey St, Muskegon, MI 49441", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Serves Norton Shores, Roosevelt Park, and southern Muskegon County. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "GRR",
      name: "Gerald R. Ford International Airport",
      distance: "Approximately 50 minutes south of Muskegon via US-131",
      address: "5500 44th St SE, Grand Rapids, MI 49512",
      note: "Primary airport for Muskegon and West Michigan. Direct flights to Atlanta, Dallas, Orlando, and seasonal Caribbean destinations. Most international connections through Atlanta or Dallas.",
      flightUrl: "https://www.grr.org/",
      flightLabel: "GRR Flight Info",
      featured: true,
    },
    {
      code: "MKG",
      name: "Muskegon County Airport",
      distance: "Approximately 5 miles south of downtown Muskegon",
      address: "1099 E Keating Ave, Muskegon, MI 49442",
      note: "Regional airport for Muskegon County. Limited commercial service with connections to larger hubs. General aviation and charter services available.",
      flightUrl: "https://www.flymkg.com/",
      flightLabel: "MKG Flight Info",
      featured: false,
    },
    {
      code: "DTW",
      name: "Detroit Metro Airport (DTW)",
      distance: "Approximately 3 hours southeast of Muskegon via US-131 and I-96",
      address: "11050 W G Rogell Dr, Detroit, MI 48242",
      note: "Major international hub for Muskegon travelers seeking more international routes. Delta Airlines hub with extensive global connections.",
      flightUrl: "https://www.metroairport.com/",
      flightLabel: "DTW Flight Info",
      featured: false,
    },
  ],
};